import router from './router'
import BranchMessages from './localization'

export default {
  router,
  localization: BranchMessages,
}
